import React, { useState, useEffect } from "react";
import Button from "../../atoms/Button";
import { useDispatch } from "react-redux";
import { getAllWishlist } from "../../../utils/API/getAllWishlistProject";
import { deleteWishlistItem } from "../../../utils/API/deleteWishlist";
import Pagination from "../../atoms/Pagination";
import AllWishListLoader from "../../molecules/AllWishlistLoader";
import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  removeFromWishlist,
  setToWishlist
} from "../../../redux/slices/wishlist-slice";
import { getRegistryImage } from "../../../utils/helper/getRegistryImage";

const WishListCard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [wishlist, setWishlist] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0
  });
  const currentPage = Number(searchParams.get("page")) || 1;
  const pageSize = 12;
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getAllWishlist({ page: currentPage, pageSize }, dispatch)
      .then((data) => {
        setWishlist(data.data.paginatedData);
        dispatch(setToWishlist(data.data.paginatedData));
        setPagination({
          totalItems: data.data.totalDocs,
          totalPages: data.data.totalPages
        });
      })
      .catch((error) => {
        console.error("Error fetching wishlist data:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentPage]);

  const handleRemoveFromWishlist = (itemId) => {
    deleteWishlistItem(itemId)
      .then(() => {
        const updatedWishlist = wishlist.filter((item) => item._id !== itemId);
        setWishlist(updatedWishlist);
        dispatch(removeFromWishlist({ id: itemId }));
      })
      .catch((error) => {
        console.error("Failed to delete wishlist item:", error);
      });
  };
  const onBidClick = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(
      `/bid?projectId=${item.projectDetails._id}&userId=${item.credit_owner}`
    );
  };

  return (
    <div>
      {isLoading && (
        <div>
          {" "}
          <AllWishListLoader />
        </div>
      )}

      {!isLoading && (
        <div className="flex flex-wrap">
          {wishlist.map((item) => (
            <Link
              to={`/project-details?projectId=${item.projectDetails._id}&userId=${item.credit_owner}& inquire=${item.is_enquire_required}`}
              key={item._id}
              className="w-[calc(100%/4)] p-2"
            >
              <div className="w-full p-1 rounded-lg shadow-custom bg-white block">
                <img
                  src={item.projectDetails.cover_image}
                  alt="project image"
                  className="w-full rounded-lg h-[140px] bg-cover relative"
                />
                <div className="flex justify-between mx-2 mt-1">
                  <div className="flex gap-1">
                    <svg
                      fill="#000000"
                      width="10px"
                      height="10px"
                      viewBox="0 0 24 24"
                      baseProfile="tiny"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M17.657 5.304c-3.124-3.073-8.189-3.073-11.313 0-3.124 3.074-3.124 8.057 0 11.13l5.656 5.565 5.657-5.565c3.124-3.073 3.124-8.056 0-11.13zm-5.657 8.195c-.668 0-1.295-.26-1.768-.732-.975-.975-.975-2.561 0-3.536.472-.472 1.1-.732 1.768-.732s1.296.26 1.768.732c.975.975.975 2.562 0 3.536-.472.472-1.1.732-1.768.732z" />
                    </svg>
                    <span className="text-[8px] font-light text-[#252525]">
                      {item.projectDetails.location.state +
                        ", " +
                        item.projectDetails.location.country}
                    </span>
                  </div>
                  <div className="flex gap-2">
                    <span className="text-[8px] font-light text-blue-800">
                      {item.categoryInfo.name}
                    </span>
                    <img
                      src="images/checkedWishlist.svg"
                      alt=""
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleRemoveFromWishlist(item._id);
                      }}
                    />
                  </div>
                </div>
                <div className="px-2 pt-1">
                  <div className="flex justify-between items-center">
                    <h4 className="text-xl font-bold w-[75%] truncate">
                      {item.projectDetails.project_name}
                    </h4>
                    <span className="text-[8px] font-medium text-blue-800 leading-4">
                      OG Score - {item.projectDetails.OG_score}
                    </span>
                  </div>
                  <div className="flex mt-2">
                    <div className="text-[8px] font-bold text-[#000] opacity-60 leading-4">
                      Listed Credits - {item.holdingsDetails.available_credits}{" "}
                      |
                    </div>
                    <div className="text-[8px] font-bold text-[#252525] opacity-60 leading-4">
                      &nbsp; Total Credits -{" "}
                      {item.holdingsDetails.number_Of_Credits}
                    </div>
                  </div>
                  <div className="flex justify-between items-center">
                    <div className="text-[8px] font-bold text-[#252525] opacity-60 leading-4">
                      <span> {item.projectDetails.type_of_credit}</span>
                    </div>
                    {!item.is_enquire_required ? (
                      <div>
                        ${item.holdingsDetails.price_per_credit}/Credits
                      </div>
                    ) : (
                      <span className="text-[10px] text-blue-800 font-medium">
                        This Project is not Listed
                      </span>
                    )}
                  </div>
                  <div className="flex justify-between">
                    <div className="w-14 flex items-center h-14">
                      <img
                        src={getRegistryImage(
                          item.registryDetails.registryName
                        )}
                        alt="registry-icon"
                      />
                    </div>
                    {!item.is_enquire_required ? (
                      <span className="ml-4 block">
                        <Button
                          variant="primary"
                          borderColor="blue"
                          className="px-10 py-2 text-sm text-white bg-blue-800 rounded-md"
                          onClick={(e) => onBidClick(e, item)}
                        >
                          Bid
                        </Button>
                      </span>
                    ) : (
                      item.is_enquire_required && (
                        <span className="ml-4 block">
                          <Button
                            variant="primary"
                            borderColor="none"
                            className="px-7 py-2 text-sm text-blue-800 bg-blue-300 rounded-md"
                            //  onClick={onInquireClick}
                          >
                            Inquire
                          </Button>
                        </span>
                      )
                    )}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}

      {pagination.totalPages > 1 && (
        <div className="pb-4 px-3">
          <Pagination
            current={currentPage}
            total={pagination.totalItems}
            pageSize={pageSize}
            setCurrentPage={(page) => setSearchParams({ page })}
          />
        </div>
      )}
    </div>
  );
};

export default WishListCard;
